export function getApiKey(): string {
  if (process.env.NODE_ENV === 'development') {
    return 'AIzaSyCFrX7hqce9GvgDWvAtaT8No7i29UaHUUM' // Test IH-Web:
  }
  return 'AIzaSyDat41J6piHZv6e-_epKfPLXtrTHWTh-4k'
}
